// extracted by mini-css-extract-plugin
module.exports = {"svg":"svg_svg___eRbn"};